import doImg from "assets/images/news/do.jpeg";
import the_rev from "assets/images/news/the_rev.jpeg";
import we_collection from "assets/images/news/we_collection.jpeg";
import we_platform from "assets/images/news/we_platform.jpeg";

const News = () => {
  let newsData = [
    { title: `The Revolution will not be Televised…it will be Live-Streamed! 📱`, url: `https://medium.com/@WeStream/the-revolution-will-not-be-televised-it-will-be-live-streamed-d3fc2262a07a`, img: the_rev },
    { title: `Do we need a new video sharing platform for Web 3.0? 📺`, url: `https://medium.com/@WeStream/do-we-need-a-new-video-sharing-platform-for-web-3-0-e4861459a1e7`, img: doImg },
    { title: `WeStream — The Free-to-Use Decentralized Live-Streaming Platform! 🚀`, url: `https://medium.com/@WeStream/westream-the-free-to-use-decentralized-live-streaming-platform-b9109a536b1e`, img: we_platform },
    { title: `WeStreamers NFT Collection 🖼`, url: `https://medium.com/@WeStream/westreamers-nft-collection-3404619fe7c3`, img: we_collection },
  ];
  return (
    <section id="news">
      <div className="container">
        <div className="sec-heading-wrapper">
          {/* ================= Main Heading ===================== */}
          <h1 className="sec-heading" data-aos="fade-up">
            News
          </h1>
        </div>
        <br />
        <div className="row news-row">
          {newsData?.map((item, i) => (
            <div data-aos="fade-up" className="news-col" key={i}>
              <a style={{backgroundImage: `url('${item.img}')`}} href={item.url} target="_blank" rel="noopener noreferrer" className="news-card">
                {/* <img src={item.img} alt="" /> */}
                <h3>{item.title}</h3>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default News;
